module.exports = __webpack_public_path__ + "img/icn-hzc.90f66b6a.png";